import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'roundToK'
})
export class RoundToKPipe implements PipeTransform {
  transform(value: number): string | number {
  if(value > 1000){
    const roundedValue = Math.round(value / 1000);
    return `${roundedValue}K`;
  }
    return value;
  }
}
